import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import useProductColumns from "./Hooks/useProductColumns";
import AffinityGroupFilter from "../../AG/AffinityGroup/AffinityGroupFilter";
import CommonHeader from "../../../Components/Common/CommonHeader/CommonHeader";
import TableWrapper from "../../../Components/Common/Tables/Tanstack/components/TableWrapper";
import { resetFormState } from "../../../slices/common/reducer";
import {
  btnAccessChecker,
  checkButtonAccess,
  getOrgId,
} from "../../../Utils/CommonUtils";
import {
  getFilteredDataWithTabs,
  getListingByOrgId,
} from "../../../Utils/CommonService";
import {
  setProductData,
  setProductFilterForm,
  setProductSorting,
} from "../../../slices/product/productSlice";
import ProductFilter from "./ProductFilter";

const ProductListing = () => {
  const dispatch = useDispatch();
  const { productColumns } = useProductColumns();
  const productData = useSelector((state) => state.product.productData);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const totalRows = useSelector((state) => state.common.pagination.totalCount);
  const apiTabData = useSelector((state) => state.common.pagination.tabs);
  const filterApi = useSelector((state) => state.product.filter.filterApi);
  const filterForm = useSelector((state) => state.product.filter.form);
  const sortColumn = useSelector((state) => state.product.sorting.column);
  const sortOrder = useSelector((state) => state.product.sorting.order);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;
  const enterpriseid = localStorage.getItem("enterpriseid");

  // const totalRows = productData ? productData.length : 0;
  // useEffect(() => {
  //   dispatch(resetFormState());
  //   getListingByOrgId("PPET", organizationId, setProductData);
  // }, [organizationId, triggerRender]);
  useEffect(() => {
    dispatch(resetFormState());
    dispatch(setProductFilterForm({ type: "reset" }));
  }, []);

  return (
    <div>
      {/* <div onClick={getSideBarData}></div> */}
      <CommonHeader
        title={"Product"}
        newButton={true}
        checkAccessCreate={checkButtonAccess("CREATE", "PROD_PRO")}
        formLink="/prod/product/create"
        deletebtn={true}
        buttonTitle={"New Product"}
        filterComponent={<ProductFilter />}
        dash={true}
      />
      {/* <AffinityGroupFilter /> */}
      <div>
        {/* <TableWrapper
          columns={productColumns}
          data={productData}
          // apiTabData={apiTabData}
          //   paginatedApi
          //   filterApi
          //   filterApiEntity={"AGRP"}
          //   filterApiListEntity={"AGRP"}
          //   filterApiFunction={setAffinityGroupData}
          //   filterApiService={getListing}
          // filterForm={true}
          totalRows={totalRows}
          // status={"ALL"}
          // statusColumn={"status"}
          // download
          // handleDownload={handleDownload}
          hideTabs
        /> */}
        <TableWrapper
          columns={productColumns}
          data={productData}
          apiTabData={apiTabData}
          paginatedApi
          filterApi={filterApi}
          filterApiEntity={"PPET"}
          filterApiListEntity={"PPET"}
          filterApiFunction={setProductData}
          filterApiService={getFilteredDataWithTabs}
          filterForm={filterForm}
          totalRows={totalRows}
          status={"ALL"}
          statusColumn={"status"}
          hideTabsWrapper={true}
          serverSort
          serverSortColumn={sortColumn}
          serverSortOrder={sortOrder}
          serverSortState={setProductSorting}
          organizationId={organizationId}
          enterpriseId={enterpriseid}
        />
      </div>
    </div>
  );
};

export default ProductListing;
